import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';

export const draggableInputStyles = {
  icon: css`
    display: block;
  `,
  title: css`
    display: flex;
    gap: ${theme.spacing(1)};
  `,
};
